"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Formatter = void 0;
var moment = require("moment");
var Formatter = (function () {
    function Formatter() {
    }
    Formatter.readTime = function (value) {
        return moment(value, 'HH:mm:ss.SSS').toDate();
    };
    Formatter.writeTime = function (value) {
        return moment(value).format('HH:mm:ss.SSS');
    };
    Formatter.readDate = function (value) {
        return moment(value, 'YYYY-MM-DD').toDate();
    };
    Formatter.writeDate = function (value) {
        return moment(value).format('YYYY-MM-DD');
    };
    Formatter.readDateTime = function (value, utc) {
        if (utc === void 0) { utc = false; }
        var regionIndex = value.indexOf('[');
        if (regionIndex >= 0) {
            value = value.substring(0, regionIndex);
        }
        var res = moment(value, Formatter.DATETIME_FORMATS);
        return utc ? res.utc().toDate() : res.toDate();
    };
    Formatter.readZoneDateTime = function (value) {
        return Formatter.readDateTime(value);
    };
    Formatter.writeZoneDateTime = function (value) {
        return moment(value).format('YYYY-MM-DDTHH:mm:ss.SSSZ');
    };
    Formatter.readLocalDateTime = function (value) {
        return Formatter.readDateTime(value);
    };
    Formatter.writeLocalDateTime = function (value) {
        return moment(value).format('YYYY-MM-DDTHH:mm:ss.SSS');
    };
    Formatter.readUTCDateTime = function (value) {
        return Formatter.readDateTime(value, true);
    };
    Formatter.writeUTCDateTime = function (value) {
        return moment(value).utc().format('YYYY-MM-DDTHH:mm:ss.SSSZ');
    };
    Formatter.DATETIME_FORMATS = [
        'YYYY-MM-DDTHH:mm:ssZ',
        'YYYY-MM-DDTHH:mm:ss.SZ',
        'YYYY-MM-DDTHH:mm:ss.SSZ',
        'YYYY-MM-DDTHH:mm:ss.SSSZ',
        'YYYY-MM-DDTHH:mm:ss.SSSSZ',
        'YYYY-MM-DDTHH:mm:ss.SSSSSZ',
        'YYYY-MM-DDTHH:mm:ss.SSSSSSZ',
        'YYYY-MM-DDTHH:mm:ss.SSSSSSSZ',
        'YYYY-MM-DDTHH:mm:ss.SSSSSSSSZ',
        'YYYY-MM-DDTHH:mm:ss.SSSSSSSSSZ',
        'YYYY-MM-DDTHH:mm:ss',
        'YYYY-MM-DDTHH:mm:ss.S',
        'YYYY-MM-DDTHH:mm:ss.SS',
        'YYYY-MM-DDTHH:mm:ss.SSS',
        'YYYY-MM-DDTHH:mm:ss.SSSS',
        'YYYY-MM-DDTHH:mm:ss.SSSSS',
        'YYYY-MM-DDTHH:mm:ss.SSSSSS',
        'YYYY-MM-DDTHH:mm:ss.SSSSSSS',
        'YYYY-MM-DDTHH:mm:ss.SSSSSSSS',
        'YYYY-MM-DDTHH:mm:ss.SSSSSSSSS',
    ];
    return Formatter;
}());
exports.Formatter = Formatter;
//# sourceMappingURL=formatter.js.map